import { HttpHelper, HttpServiceParams } from "@ppvrbh/merchant-frontend-core";

const BASE_URL = 'v1/merchant/company-admin/menus-modifier-item';

class ModifierItemServiceClass {
    getModifierItems = (params?: HttpServiceParams<{ page?: number; limit?: number; keyword?: string }>) => {
        const searchParams = new URLSearchParams();
        if (params?.data?.page !== undefined) {
            searchParams.append('page', String(params.data.page));
        }
        if (params?.data?.limit !== undefined) {
            searchParams.append('limit', String(params.data.limit));
        }
        if (params?.data?.keyword) {
            searchParams.append('keyword', params.data.keyword);
        }
        const query = searchParams.toString() ? '?' + searchParams.toString() : '';
        return HttpHelper.get({
            url: BASE_URL + '/landing' + query,
        });
    }

    deleteModifierItems = (params: HttpServiceParams<number[]>) => {
        return HttpHelper.post({
            url: BASE_URL + '/remove',
            data: { menuModifierItemIds: params.data },
        });
    }

    toggleModifierItemStatus = (params: HttpServiceParams<{ menuModifierItemId: number; isOffline: boolean }>) => {
        return HttpHelper.patch({
            url: BASE_URL + '/toggle',
            data: {
                menuModifierItemId: params.data.menuModifierItemId,
            },
        });
    }

    createModifierItem = (params: HttpServiceParams<{
        menuModifierItemName: string;
        menuModifierItemPrice: number;
        menuModifierItemNameEN?: string;
        menuModifierItemSKUId?: string;
    }>) => {
        return HttpHelper.post({
            url: BASE_URL,
            data: params.data,
        });
    }

    updateModifierItem = (params: HttpServiceParams<{
        menuModifierItemId: number;
        menuModifierItemName?: string;
        menuModifierItemPrice?: number;
        menuModifierItemNameEN?: string;
        menuModifierItemSKUId?: string;
    }>) => {
        return HttpHelper.patch({
            url: BASE_URL,
            data: params.data,
        });
    }
}

export const ModifierItemService = new ModifierItemServiceClass();